export const SRP_SEARCH_CRITERIA = 'srp_searchCriteria'
export const SRP_SEARCH_VALUES_SCOPE = 'srp_searchValuesScope'
export const SRP_SEARCH_INFO_URL = 'srp_searchInfoUrl'
export const SRP_SEARCH_INFO = 'srp_searchInfo'
